export default __webpack_public_path__ + "static/media/violentbed.4df89a2b.png";